/***
 * Configuration for Documents Routes
 *
 * Document Routes
 * Document Type Routes
 ***/

/* ----- Views ----- */

// Document
import Documents from "@/pages/Documents/Documents";
import DocumentAdd from "@/pages/Documents/DocumentAdd";
import DocumentEdit from "@/pages/Documents/DocumentEdit";

// Document Type
import TypeAdd from "@/pages/Documents/Type/TypeAdd";
import TypeEdit from "@/pages/Documents/Type/TypeEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

const parentsList = {
    documentsIndex : { label: 'Liste des documents', name: 'Documents' },
    documentTypeDetails: {
        label: 'Modification d\'une catégorie',
        shortLabel: 'Catégorie : ',
        name: 'Edit Document Type',
        params: { name: 'idType', model: 'DocumentType', column: 'name' },
    },
}

const documentRoutes = [
    {
        path: 'documents',
        name: 'Documents',
        component: Documents,
        meta: {
            route: {
                label: 'Liste des documents'
            }
        },
    },
    {
        path: 'documents/create',
        name: 'Add Document',
        component: DocumentAdd,
        meta: {
            route: {
                label: 'Ajout d\'un document'
            },
            parents: generateParentsList(parentsList, ['documentsIndex']),
        },
    },
    {
        path: 'documents/:id/edit',
        name: 'Edit Document',
        component: DocumentEdit,
        meta: {
            route: {
                label: 'Modification d\'un document',
                params: { name: 'id', model: 'Document', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['documentsIndex']),
        },
    },
]

const documentTypeRoutes = [
    {
        path: 'documents/type/create',
        name: 'Add Document Type',
        component: TypeAdd,
        meta: {
            route: {
                label: 'Ajout d\'une catégorie'
            },
            parents: generateParentsList(parentsList, ['documentsIndex']),
        },
    },
    {
        path: 'documents/type/:idType/edit',
        name: 'Edit Document Type',
        component: TypeEdit,
        meta: {
            route: {
                label: 'Modification d\'une catégorie',
                shortLabel: 'Catégorie : ',
                params: { name: 'idType', model: 'DocumentType', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['documentsIndex']),
        },
    },
    {
        path: 'documents/type/:idType/subtype/create',
        name: 'Add Document SubType',
        component: TypeAdd,
        meta: {
            route: {
                label: 'Ajout d\'une sous-catégorie'
            },
            parents: generateParentsList(parentsList, ['documentsIndex', 'documentTypeDetails']),
        },
    },
    {
        path: 'documents/type/:idType/subtype/:idSubType/edit',
        name: 'Edit Document SubType',
        component: TypeEdit,
        meta: {
            route: {
                label: 'Modification d\'une sous-catégorie',
                shortLabel: 'Sous-catégorie : ',
                params: { name: 'idSubType', model: 'DocumentType', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['documentsIndex', 'documentTypeDetails']),
        },
    },
]

const routes = [...documentRoutes, ...documentTypeRoutes]
export default routes